import LoginModal from '../login/LoginModal';
import Button from '@ui/button/Button';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import ErrorModal from '@components/error/ErrorModal';
import WishlistContent from './WishlistContent';
import WishlistShare from './WishlistShare';
const Wishlist = (props) => {
    var _a;
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    // const [currentType, setCurrentType] = useQueryString<models.WishlistTypes>('wishlistTab', 'products');
    const [editorialBanners, setEditorialBanners] = useState();
    const [showSendWishlist, setShowSendWishlist] = useState(false);
    const [unifiedWishlist, setUnifiedWishlist] = useState();
    const [showCrossCountryModal, setShowCrossCountryModal] = useState(true);
    const [customerName, setCustomerName] = useState(props === null || props === void 0 ? void 0 : props.customerName);
    const [shareFormdef, setShareFormdef] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const isPublicWishlist = useMemo(() => { var _a, _b; return ((_a = props.querystring) === null || _a === void 0 ? void 0 : _a.includes('listId')) && ((_b = props.querystring) === null || _b === void 0 ? void 0 : _b.includes('key')) && props.publicpage; }, [props.querystring, props.publicpage]);
    const enabledShare = useMemo(() => {
        return props.shareenabled && customerName && !isPublicWishlist;
    }, [props.shareenabled, customerName, isPublicWishlist]);
    useEffect(() => {
        if (isPublicWishlist) {
            const params = new URLSearchParams(props.querystring);
            api.getJsonPublicWishlist(params.get('listId'), params.get('key')).then((data) => {
                let joinedWishlist;
                data.lists.forEach((wl) => {
                    if (!joinedWishlist) {
                        joinedWishlist = wl;
                    }
                    else {
                        joinedWishlist.items = joinedWishlist.items.concat(wl.items);
                        joinedWishlist.length += wl.length;
                        joinedWishlist.totalSize += wl.totalSize;
                    }
                });
                joinedWishlist.items.sort((a, b) => a.creationDate - b.creationDate);
                setUnifiedWishlist(joinedWishlist);
                // setMbmWishlist(data.lists.find((list) => list.literalType == 'mbm'));
                // setHideMbmTab(!!data.hideMbmTab);
                setLoading(false);
            });
        }
    }, [isPublicWishlist]);
    // add listener from outside via CustomEventBus
    useEffect(() => {
        customEventBus.on('wishlist:update', (data) => updateWishLists());
    }, []);
    const updateWishLists = async (excludeCache) => {
        return api.getWishlist('all', excludeCache).then((data) => {
            setUnifiedWishlist(data);
            setLoading(false);
            return data;
        });
    };
    const updateGiftCard = (card, formDef, callback) => {
        api.gcEditWishlistItem(card, formDef).then((data) => {
            if (data.success) {
                updateWishLists(true).then((updatedWishlist) => {
                    const newlyUpdatedProduct = updatedWishlist === null || updatedWishlist === void 0 ? void 0 : updatedWishlist.items.find((el) => el.UUID === card.gcUUID);
                    callback && callback(newlyUpdatedProduct.price);
                });
            }
            else {
                console.log(data);
            }
        });
    };
    useEffect(() => {
        if (!isPublicWishlist) {
            updateWishLists();
        }
    }, [customerName, isPublicWishlist]);
    useEffect(() => {
        if (enabledShare) {
            let val = {};
            api.getForm('wishlist-share', val).then((data) => {
                setShareFormdef(data);
            });
        }
    }, [enabledShare]);
    useEffect(() => {
        // get editorial banners, if present (currently only for the MBM part)
        api.getPageJson('wishlist').then((data) => {
            var _a, _b, _c, _d, _e, _f;
            if (!(data === null || data === void 0 ? void 0 : data.errorMessage) && ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.page) === null || _a === void 0 ? void 0 : _a.regions) === null || _b === void 0 ? void 0 : _b.main) === null || _c === void 0 ? void 0 : _c.components)) {
                setEditorialBanners((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.page) === null || _d === void 0 ? void 0 : _d.regions) === null || _e === void 0 ? void 0 : _e.main) === null || _f === void 0 ? void 0 : _f.components);
            }
        });
    }, []);
    const wishlistCount = useMemo(() => {
        if (!unifiedWishlist) {
            return;
        }
        let totalCount = (unifiedWishlist === null || unifiedWishlist === void 0 ? void 0 : unifiedWishlist.totalSize) || 0;
        return totalCount;
    }, [unifiedWishlist]);
    useEffect(() => {
        if (!!wishlistCount) {
            props.updateCount && props.updateCount(wishlistCount);
        }
    }, [wishlistCount]);
    const getCurrentWishlistUUID = (isMbm) => {
        return isMbm ? unifiedWishlist.mbmUUID : unifiedWishlist.UUID;
    };
    const localizedCurrentLocation = (countryCode) => {
        var _a;
        if (!countryCode) {
            return undefined;
        }
        const regionNamesLocalized = new Intl.DisplayNames([window.language || 'en'], { type: 'region' });
        // ovveride custom richiesto da Moncler
        let coutryNameOverride = {
            HK: t('select.option.country.hongkong'),
            MO: t('select.option.country.macau'),
            TW: t('select.option.country.taiwan'),
        };
        return (_a = coutryNameOverride[countryCode]) !== null && _a !== void 0 ? _a : regionNamesLocalized.of(countryCode);
    };
    const removeProduct = (uuid, masterid, moveToBag) => {
        var _a;
        let isMbmProduct = (_a = unifiedWishlist.items.find((p) => p.UUID == uuid)) === null || _a === void 0 ? void 0 : _a.isMbm;
        let type = isMbmProduct ? 'mbm' : 'products';
        api.removeItemFromWishlist(uuid, type).then((result) => {
            updateWishLists();
            customEventBus.emit('account:update', { wishlistIds: result.items });
            customEventBus.emit('wishlist:update', { wishlistIds: result.items });
            analytics.SaveForLaterRemoveItem(masterid);
        });
        if (unifiedWishlist.items.length == 1 && moveToBag) {
            if (props.cart) {
                props.setSentAnalytics(true);
                props.setTabIndex('bag');
                scrollTo(0, 0);
            }
            else {
                window.location.href = props.carturl;
            }
        }
    };
    const updateProduct = (oldProductId, newProductId, recipeId, callback) => {
        api.replaceWishlistProduct(getCurrentWishlistUUID(recipeId.length > 0), oldProductId, newProductId, recipeId, true).then((result) => {
            const newlyUpdatedProduct = result === null || result === void 0 ? void 0 : result.items.find((el) => el.pid === newProductId);
            callback && callback(newlyUpdatedProduct);
        });
    };
    const testButtons = (React.createElement("div", { className: "devmodebox devmode" },
        React.createElement("button", { className: "button button--primary", onClick: () => api.addToWishlist('G10911A10600530297760') }, "add product - standard"),
        React.createElement("button", { className: "button button--primary", onClick: () => api.addToWishlist('G10911A10600530297761') }, "add product - OOS"),
        React.createElement("button", { className: "button button--primary", onClick: () => api.addToWishlist('H209Z1A00001M29049992', '41432289') }, "add product - MBM"),
        React.createElement("button", { className: "button button--primary", onClick: () => api.addToWishlist('H209Z1A00002M29049991', '58519464').then(() => updateWishLists()) }, "add product - MBM 2")));
    if (loading) {
        return React.createElement("div", { className: "wishlist-skeleton", dangerouslySetInnerHTML: { __html: props === null || props === void 0 ? void 0 : props.placeholder } });
    }
    return (React.createElement(React.Fragment, null,
        ((_a = props.querystring) === null || _a === void 0 ? void 0 : _a.includes('test')) && testButtons,
        wishlistCount === 0 ? (React.createElement("div", { className: "container" },
            !isPublicWishlist && !window.loggedin && (React.createElement("div", { className: "wishlist" },
                React.createElement("div", { className: "wishlist__intro" }, window.country !== 'RU' && (React.createElement(LoginModal, Object.assign({ incontext: "wishlist" }, props, { reloadPage: true, socialLoginTarget: 'wishlist', registerDestination: 'wishlist', inWishlist: true, updateLoggeedStatus: (name) => setCustomerName(name), linkreload: isPublicWishlist ? props.loggedPageUrl : undefined, analyticsKey: "modal" })))))),
            React.createElement("div", { className: "wishlist--empty" },
                React.createElement("p", { role: "region", "aria-live": "polite" }, t('bag.wishlistempty')),
                React.createElement("div", { className: "wishlist--empty__button-container" },
                    React.createElement("a", { href: window.homeurl, className: "button button--secondary", onClick: () => analytics.wishlistInteractionBack() },
                        React.createElement("span", null, t('button.backtoshopping'))))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames({ container: !(props === null || props === void 0 ? void 0 : props.mymoncler) }, 'wishlist') },
                !isPublicWishlist && (React.createElement("div", { className: "wishlist__intro" },
                    React.createElement(LoginModal, Object.assign({ incontext: "wishlist" }, props, { reloadPage: true, socialLoginTarget: 'wishlist', registerDestination: 'wishlist', inWishlist: true, updateLoggeedStatus: (name) => setCustomerName(name), linkreload: isPublicWishlist ? props.loggedPageUrl : undefined, analyticsKey: "modal" })))),
                React.createElement("div", { className: "wishlist__intro row align-middle" },
                    React.createElement("div", { className: "col-12 col-md-4 offset-md-4" },
                        React.createElement("span", { dangerouslySetInnerHTML: {
                                __html: t('wishlist.itemsfound', { number: unifiedWishlist === null || unifiedWishlist === void 0 ? void 0 : unifiedWishlist.totalSize }),
                            } })),
                    enabledShare && !window.isClothing && (React.createElement("div", { className: "col-12 col-md-4" },
                        React.createElement("button", { type: "button", className: "wishlist__share-button", onClick: () => {
                                api
                                    .GeneratePublicWishlist(unifiedWishlist.UUID)
                                    .then((data) => {
                                    if (data.success) {
                                        unifiedWishlist.shareWishlistsUrl = data.urlRedirect;
                                        setShowSendWishlist(true);
                                    }
                                    else {
                                        setErrorMessage(t('errorpage.text'));
                                    }
                                })
                                    .catch((e) => setErrorMessage(t('errorpage.text')));
                                analytics.wishlistInteractionShare('');
                            }, "aria-expanded": showSendWishlist ? 'true' : 'false', "aria-haspopup": "dialog" }, t('wishlist.share')),
                        React.createElement(WishlistShare, { wishlist: unifiedWishlist, show: showSendWishlist, setShow: setShowSendWishlist, formdef: shareFormdef }),
                        React.createElement(ErrorModal, { message: errorMessage, onClose: () => setErrorMessage(undefined) })))),
                React.createElement(WishlistContent, Object.assign({}, props, { type: 'products', wishlist: unifiedWishlist, removeProduct: removeProduct, updateProduct: updateProduct, banners: editorialBanners === null || editorialBanners === void 0 ? void 0 : editorialBanners.filter((banner) => banner.list_type == 'standard'), inMymoncler: props.mymoncler, inPublicWishlist: isPublicWishlist, shareenabled: enabledShare, shareformdef: shareFormdef, updateWishLists: updateWishLists, updateGiftCard: updateGiftCard }))),
            isPublicWishlist && props.currentCountry != window.country && (React.createElement(ModalDialog, { overlayClassName: 'mobile-visible', className: "modal--fixed-small cross-country-info", isOpen: showCrossCountryModal, onRequestClose: () => setShowCrossCountryModal(false), contentLabel: t('wishlist.crosscountrytitle', { 0: localizedCurrentLocation(props.currentCountry) }) },
                React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "mb-16" }, t('wishlist.crosscountrydesc', { 0: localizedCurrentLocation(window.country), 1: window.country })),
                    React.createElement(Button, { type: 'button', cls: ['button--primary'], onClick: () => setShowCrossCountryModal(false) }, t('button.continue')))))))));
};
export default Wishlist;
